import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import handleAsyncThunk from "../handleAsyncThunk";
import contactApi from "../../service/contactApi";
import { showSuccessSnackbar, showErrorSnackbar } from "./snackbarSlice";

export const createNewContact = createAsyncThunk("contact/createNewContact", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await contactApi.addNewContact(data);
    if (response.status === 201) {
      dispatch(showSuccessSnackbar({ title: "Contact created successfully" }));
      return response?.data;
    } else {
      dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
      return rejectWithValue(response?.message);
    }
  } catch (error) {
    dispatch(showErrorSnackbar({ title: error?.message }));
    return rejectWithValue(error.message);
  }
});

export const getContacts = createAsyncThunk("contact/getContacts", async (data, { rejectWithValue, dispatch }) => {
  try {
    const queryString = data?.q ? `?q=${data.q}` : '';
    const response = await contactApi.getContacts(queryString);
    if (response.status === 200) {
      // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));
      return response?.data;
    } else {
      dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
      return rejectWithValue(response?.message);
    }
  } catch (error) {
    dispatch(showErrorSnackbar({ title: error?.message }));
    return rejectWithValue(error.message);
  }
});

//search contact using query parameter https://api.cannamart.ca/mock/contact?q=firstName:First1




export const fetchSearchedContacts = createAsyncThunk(
  "contact/fetchSearchedContacts",
  async (queryObj, { rejectWithValue, dispatch }) => {
    try {
      console.log('Starting fetchSearchedContacts with query:', queryObj);
      // Construct query string from queryObj (e.g., { firstName: "First1" } => "firstName:First1")
      const queryString = queryObj ? `?q=${Object.entries(queryObj).map(([key, value]) => `${key}:${value}`).join(',')}` : '';
      console.log('Constructed query string:', queryString);
      const response = await contactApi.searchContact(queryString);
      console.log('API response received:', {
        status: response.status,
        data: response.data,
        headers: response.headers,
      });
      if (response.status === 200) {
        console.log('fetchSearchedContacts successful, data:', response.data);
        return response?.data;
      } else {
        console.error('fetchSearchedContacts failed with status:', response.status, 'Message:', response?.message);
        dispatch(showErrorSnackbar({ title: response?.message || "Failed to fetch searched contacts" }));
        return rejectWithValue(response?.message);
      }
    } catch (error) {
      console.error('fetchSearchedContacts error:', {
        message: error.message,
        stack: error.stack,
      });
      dispatch(showErrorSnackbar({ title: error?.message || "Error searching contacts" }));
      return rejectWithValue(error.message);
    }
  }
);

export const getContactById = createAsyncThunk("contact/getContactById", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await contactApi.getContactById(data);
    if (response.status === 200) {
      // dispatch(showSuccessSnackbar({ title: "Contacts fetched successfully" }));

      return response?.data;
    } else {
      dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
      return rejectWithValue(response?.message);
    }
  } catch (error) {
    dispatch(showErrorSnackbar({ title: error?.message }));
    return rejectWithValue(error.message);
  }
});

export const updateContact = createAsyncThunk("contact/updateContact", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await contactApi.updateContact(data);
    if (response.status === 200) {
      dispatch(showSuccessSnackbar({ title: "Contact Updated successfully" }));
      return response?.data;
    } else {
      dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
      return rejectWithValue(response?.message);
    }
  } catch (error) {
    dispatch(showErrorSnackbar({ title: error?.message }));
    return rejectWithValue(error.message);
  }
});

export const deleteContact = createAsyncThunk("contact/deleteContact", async (data, { rejectWithValue, dispatch }) => {
  try {
    const response = await contactApi.deleteContact(data);

    if (response.status === 204) {
      dispatch(showSuccessSnackbar({ title: "Contact deleted successfully" }));
      return response?.data;
    } else {
      dispatch(showErrorSnackbar({ title: response?.message || "Something went wrong" }));
      return rejectWithValue(response?.message);
    }
  } catch (error) {
    dispatch(showErrorSnackbar({ title: error?.message }));
    return rejectWithValue(error.message);
  }
});


const contactSlice = createSlice({
  name: "contact",
  initialState: {
    data: null,
    status: null,
    error: null,
    isLoading: false,
    contacts: [],
    contactList: [],
    contactListLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    handleAsyncThunk(builder, createNewContact, "data", "error", "contactLoading");
    handleAsyncThunk(builder, getContacts, "contacts", "error", "contactsListLoading");
    handleAsyncThunk(builder, getContactById, "contactById", "error", "contactByIdLoading");
    handleAsyncThunk(builder, deleteContact, "data", "error", "deleteContactLoading");
    handleAsyncThunk(builder, updateContact, "data", "error", "updateContactLoading");
    handleAsyncThunk(builder, fetchSearchedContacts, "contactList", "error", "contactListLoading");

    // builder
    //   .addCase(fetchSearchedContacts.pending, (state) => {
    //     state.contactListLoading = true;
    //   })
    //   .addCase(fetchSearchedContacts.fulfilled, (state, action) => {
    //     state.contactListLoading = false;
    //     state.contactList = action.payload;
    //   })
    //   .addCase(fetchSearchedContacts.rejected, (state, action) => {
    //     state.contactListLoading = false;
    //     state.error = action.payload;
    //   });
  },
});

export default contactSlice.reducer;
